import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var Loader = function Loader() {
    return /*#__PURE__*/ _jsx("div", {
        className: "flex items-center justify-center",
        style: {
            height: '100vh'
        },
        children: /*#__PURE__*/ _jsx("div", {
            className: "w-12 h-12 border-4 border-[var(--color-loader-bg)] border-t-transparent rounded-full animate-spin"
        })
    });
};
